import React from "react";
import { TextArea as SolasTextArea } from "@boi/react-components";
import { iControlProps } from "../types";
import { inputSafeProps } from "./input";
import Container from "./container";
import { Box } from "../../theme/containers";

export type TextAreaProps = iControlProps & {
    maxLength: number | string;
    readOnly?: boolean;
    disabled?: boolean;
    error?: string;
};

type onChangeEvent = {
    target: {
        value: string;
    };
};

const TextArea = (props: TextAreaProps) => {
    const { cssClass, maxLength, value, error } = props;
    const readOnly = cssClass && cssClass.includes("readonly") ? true : false;
    const disabled = cssClass && cssClass.includes("disabled") ? true : false;
    const valueLength = value && typeof value === "string" ? value.length : 0;
    const charLengthMessage = maxLength && (
        <Box key="charLengthMessage">
            {`${valueLength} of ${maxLength} characters`}
        </Box>
    );

    return (
        <Container
            {...props}
            error={error ? [charLengthMessage, error] : error}
        >
            <SolasTextArea
                labelProps={{}}
                {...inputSafeProps({
                    readOnly,
                    disabled,
                    ...props
                })}
                value={value}
                onChange={(e: onChangeEvent) => { props.onChange && props.onChange(e.target.value)}}
            />
            {maxLength && !error && <Box mt={1}>{charLengthMessage}</Box>}
        </Container>
    );
};

export default TextArea;
